import { apiSlice } from 'store/api/apiSlice';

import { FeedbackListProps, FeedbackQueryParams } from './customerFeedback.types';

export const customerFeedbackApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getCustomerFeedbacks: build.query<FeedbackListProps, { params: FeedbackQueryParams }>({
      query: ({ params }) => ({ params, url: `/admin/feedbacks` }),
      transformResponse: (response: FeedbackListProps) => ({
        data: response.data,
        info: response.info
      })
    })
  })
});

export const { useLazyGetCustomerFeedbacksQuery } = customerFeedbackApi;
